import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import api from '@/lib/api';

const REF_KEY = 'sparky_referral_code';

export function useReferralTracker() {
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const ref = searchParams.get('ref');
    if (ref) {
      sessionStorage.setItem(REF_KEY, ref);
      api.post('/referrals/track', {
        referral_code: ref,
        page_url: window.location.href,
      }).catch(() => {});
    }
  }, [searchParams]);
}

export function getReferralCode() {
  return sessionStorage.getItem(REF_KEY) || '';
}

export function clearReferralCode() {
  sessionStorage.removeItem(REF_KEY);
}
